import { RemoveCircleOutlined } from "@mui/icons-material";
import { styled } from "@mui/material";

const StyledDivContainer = styled("div")(({ noTopMargin }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: noTopMargin ? "0" : "40vh",
}));

const StyledDivIconContainer = styled("div")({
    textAlign: "center",
});

const StyledDivAlertText = styled("div")({
    fontSize: "22px",
});

const ErrorMessage = (props) => {
    const { message, Icon = RemoveCircleOutlined, noTopMargin } = props;

    return (
        <StyledDivContainer noTopMargin={noTopMargin}>
            <StyledDivIconContainer>
                <Icon style={{ fill: "rgb(224, 68, 3)" }} />
            </StyledDivIconContainer>
            {message ? (
                <StyledDivAlertText>{message}</StyledDivAlertText>
            ) : (
                <StyledDivAlertText>You do not have permission to view this page</StyledDivAlertText>
            )}
        </StyledDivContainer>
    );
};

export default ErrorMessage;
